import marked from 'marked'
import toUpper from 'lodash/toUpper'
import { replaceLocation } from 'Services/regionArticleReplacer'
import { ApiServiceType, CategoryInfo, CategoryInfoImages } from 'Types'

const parseImage = (data: ApiServiceType): CategoryInfoImages => {
  const mobile = {
    webp: data.categoryImageMobileWebpUrl,
    jpeg: data.categoryImageMobileUrl,
  }

  const desktop = {
    webp: data.categoryImageDesktopWebpUrl,
    jpeg: data.categoryImageDesktopUrl,
  }

return { mobile, desktop }
}

const parseSlug = (data: ApiServiceType) => {
  const category = typeof data.categorySlug !== 'undefined'
    ? data.categorySlug
    : data.slug

  const serviceType = typeof data.categorySlug !== 'undefined'
    ? data.slug
    : ''

  return { category, serviceType }
}

const parseBreadcrumb = (data: ApiServiceType) => {
  const category = typeof data.categorySlug !== 'undefined'
    ? data.categoryName
    : data.name

  const serviceType = typeof data.categorySlug !== 'undefined'
    ? data.name
    : ''

  return { category, serviceType }
}

/**
 * @param {ApiCategoryDirectoryLocation} data
 * @returns {CategoryInfoRegion}
 */
const parseRegion = (data) => {
  const hasLocation =
    typeof data !== 'undefined'
    && data !== null

  return {
    id: hasLocation ? data.idCity : null,
    city: hasLocation ? data.nameCity : '',
    state: hasLocation ? toUpper(data.ufState) : '',
  }
}

export const parseInfoQuotation = (data: ApiServiceType): CategoryInfo => ({
  id: data.id,
  group: data.groupName,
  name: data.name,
  title: data.longTailName,
  description: data.description,
  metaTite: data.metaTitle,
  metaDescription: data.metaDescription,
  icon: '',
  breadcrumb: parseBreadcrumb(data),
  images: parseImage(data),
  slug: parseSlug(data),
})

/**
 * @param {ApiCategoryDirectory} data
 * @returns {CategoryInfo}
 */
export const parseInfoDirectory = (data) => {
  const { serviceType, location } = data

  let slug = parseSlug(serviceType)

  if (location) {
    slug.region = location.slug
  }

  return {
    id: serviceType.id,
    group: serviceType.groupName,
    name: serviceType.name,
    title: location
      ? replaceLocation(serviceType.longTailNameLocation, location)
      : serviceType.longTailName,
    description: location
      ? replaceLocation(serviceType.descriptionLocation, location)
      : serviceType.description,
    metaTite: location
      ? replaceLocation(serviceType.metaTitleLocation, location)
      : serviceType.metaTitle,
    metaDescription: location
      ? replaceLocation(serviceType.metaDescriptionLocation, location)
      : serviceType.metaDescription,
    icon: '',
    breadcrumb: parseBreadcrumb(serviceType),
    region: parseRegion(location),
    images: parseImage(serviceType),
    slug,
  }
}

/**
 * @param {string} data
 * @returns {string}
 */
export const parseUsefulInformation = (data) => {
  if (typeof data === 'undefined' || data === null) {
    return null
  }

  const renderer = new marked.Renderer()
  renderer.link = (href, title, text) => `<a target="_blank" rel="noopener noreferrer" href="${href}" title="${title || text}">${text}</a>`;

  const markup = marked(data, { renderer: renderer })

  return markup
}

export default {
  parseInfoQuotation,
  parseInfoDirectory,
  parseUsefulInformation
}